import { __rest } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import MuiBox from '@mui/material/Box';
import MuiTypography from '@mui/material/Typography';
import { ReactComponent as ForwardRef } from '../../../assets/icons/CircleSmall.svg.js';
import Hint from '../../Hint/Hint.js';

const _Circle = styled(ForwardRef, {
    shouldForwardProp: prop => !['today', 'modified'].includes(prop),
}) `
  display: ${({ modified }) => (modified ? 'block' : 'none')};
  position: absolute;
  top: 50%;
  left: 50%;
  margin: ${({ theme }) => theme.spacing(0.5, 0, 0, 0)};
  transform: translate(-50%, 60%) scale(0.5);
  margin: ${({ theme }) => theme.spacing(0.5, 0, 0, 0)};
  z-index: 9;
  circle {
    stroke: ${({ theme, today }) => (today ? theme.palette.N90.main : 'none')};
    fill: ${({ theme }) => theme.palette.warning.main};
  }
`;
const Root = styled(MuiBox, {
    shouldForwardProp: prop => !['error', 'selected', 'today', 'active'].includes(prop),
}) `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  :before {
    content: '';
    display: none;
    position: absolute;
    top: 2px;
    left: 2px;
    right: 2px;
    bottom: 2px;
    border-radius: 50%;
  }
  ${({ disabled }) => disabled &&
    `
    opacity: 0.5;
    cursor: not-allowed;
  `};
  ${({ theme, error, active, today, selected, disabled }) => `
    ${!disabled &&
    `:hover {
        ${!today && `color: ${theme.palette.primary.main}`};
        ${!today && !selected && active && `color: ${theme.palette.primary.light}`};
        :before {
          background-color: ${theme.palette.primary.light};
        }
      }`};
    color: ${theme.palette.N20.main};
    ${active && `color: ${theme.palette.common.white}`};
    ${selected && `color: ${theme.palette.primary.main}`};
    ${error && `color: ${theme.palette.error.main}`};
    ${today &&
    `> p {
        color: ${theme.palette.N80.main} !important;
      }`};
    :before {
      ${today && `display: block`};
      background-color: ${theme.palette.primary.main};
      ${error && `background-color: ${theme.palette.error.main}`};
    }
  `}
`;
const Label = styled(MuiTypography) `
  position: absolute;
  margin: 0 auto;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 5;
`;
const DayContent = (_a) => {
    var { children, hint, modified, today, selected, disabled } = _a, rest = __rest(_a, ["children", "hint", "modified", "today", "selected", "disabled"]);
    const doNothingIfDisabled = (e) => {
        if (disabled) {
            e.stopPropagation();
        }
    };
    return (jsx(Hint, Object.assign({ title: hint }, { children: jsxs(Root, Object.assign({}, rest, { disabled: disabled, selected: selected, today: today, onClick: doNothingIfDisabled }, { children: [jsx(Label, Object.assign({ variant: today || selected ? 'body2' : 'body1' }, { children: children })), jsx(_Circle, { today: today, modified: modified })] })) })));
};

export { DayContent as default };
//# sourceMappingURL=DayContent.js.map
